import React, { FunctionComponent } from "react";
import { ValidationError } from "yup";
interface IProps {
	errors: any;
	field: string;
}

export const InputErrorMessage: FunctionComponent<IProps> = props => {
	if (!props.errors) {
		return null;
	}

	let errorString;
	const validationMessages = props.errors.inner.filter(
		(val: ValidationError) => {
			return val.path === props.field;
		},
	);

	if (validationMessages[0]) {
		errorString = validationMessages[0].message;
	}

	return errorString ? (
		<span style={{ color: "red" }}>{errorString}</span>
	) : null;
};
